@if (show) {
    <mat-progress-bar [mode]="mode" [value]="progress"></mat-progress-bar>

    <fuse-loading-screen>
        <img src="images/logo/logo-text-on-dark.webp" [alt]="'logo'" />
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </fuse-loading-screen>
}
